var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavprofileicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 30C52.5 33.9782 50.9196 37.7936 48.1066 40.6066C45.2936 43.4196 41.4782 45 37.5 45C33.5218 45 29.7064 43.4196 26.8934 40.6066C24.0804 37.7936 22.5 33.9782 22.5 30C22.5 26.0218 24.0804 22.2064 26.8934 19.3934C29.7064 16.5804 33.5218 15 37.5 15C41.4782 15 45.2936 16.5804 48.1066 19.3934C50.9196 22.2064 52.5 26.0218 52.5 30Z",
    fill: "#FAF6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.97 74.97C15.9694 74.1675 0 57.6975 0 37.5C0 16.7888 16.7888 0 37.5 0C58.2113 0 75 16.7888 75 37.5C75 58.2113 58.2113 75 37.5 75H36.9862C36.6462 75 36.3075 74.99 35.97 74.97ZM13.4363 61.1625C13.1559 60.3573 13.0604 59.4993 13.157 58.6522C13.2536 57.8051 13.5398 56.9906 13.9942 56.2692C14.4487 55.5479 15.0597 54.9381 15.7821 54.4852C16.5045 54.0323 17.3196 53.7479 18.1669 53.6531C32.7844 52.035 42.3056 52.1812 56.8519 53.6869C57.7003 53.7752 58.5174 54.056 59.2409 54.5079C59.9645 54.9598 60.5753 55.5708 61.027 56.2944C61.4787 57.0181 61.7593 57.8353 61.8474 58.6837C61.9356 59.5322 61.8289 60.3896 61.5356 61.1906C67.7702 54.8832 71.2616 46.3687 71.25 37.5C71.25 18.8606 56.1394 3.75 37.5 3.75C18.8606 3.75 3.75 18.8606 3.75 37.5C3.75 46.7175 7.44563 55.0725 13.4363 61.1625Z",
    fill: "#FAF6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavprofileicon);
export default __webpack_public_path__ + "static/media/sidenavprofileicon.f8461688b345ead673e44d76680a6ab4.svg";
export { ForwardRef as ReactComponent };